import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

type StyledCustomTypographyProps = {
	colorText: string
	fontStyle?: 'italic'
}

const StyledCustomTypography = styled(Typography, {
	shouldForwardProp: prop => prop !== 'colorText' && prop !== 'fontStyle',
})<StyledCustomTypographyProps>(({ colorText, fontStyle }) => ({
	display: 'inline-block',
	color: colorText,
	fontStyle,
	// fontWeight: bold,
	'&.pseudo-link': {
		textDecoration: 'underline',
		':hover': {
			cursor: 'pointer',
		},
	},
	'&.flex': {
		display: 'flex',
	},
	'&.align-items-end': {
		alignItems: 'end',
	},
	'&.justify-content-end': {
		justifyContent: 'end',
	},
	'&.h-100': {
		height: '100%',
	},
	'&.mr-16': {
		marginRight: '16px',
	},
}))

type CustomTypographyProps = {
	children: string | undefined
	colorText: string
	className?: string
	onClick?: (event: React.MouseEvent<HTMLElement>) => void
	fontStyle?: 'italic'
	// bold?: string
}

const CustomTypography = ({
	children,
	colorText,
	onClick,
	className,
	fontStyle,
}: CustomTypographyProps) => {
	return (
		<StyledCustomTypography
			colorText={colorText}
			{...(onClick && { onClick })}
			className={className}
			fontStyle={fontStyle}
		>
			{children}
		</StyledCustomTypography>
	)
}

export default CustomTypography
